import React, {
	useRef,
	useState,
	useEffect,
	useMemo,
	useCallback,
} from 'react';
import { useNavigate } from 'react-router-dom';
import NavBar from '../../../components/NavBar';
import { FiLink } from 'react-icons/fi';
// import Loading from '../../../components/Loading'

import Cookies from 'js-cookie';
import {
	requestBibliotecaRepositorios,
	requestBibliotecaDocumentosCreate,
	requestBibliotecaCategorias,
	bibliotecaRepositoriosCategorias,
	requestBibliotecaTemasList,
	bibliotecaRepositoriosTemas,
	bibliotecaPublicosAlvos,
} from '../../../services/requests';

export default function GestaoArquivos() {
	const navigate = useNavigate();
	const fileInputRef = useRef(null);

	// Estados para carregar dados da API
	const [repositoriosUnicos, setRepositoriosUnicos] = useState([]);
	// Listas carregadas por repositório selecionado
	const [repositoriosApi, setRepositoriosApi] = useState([]);
	const [categoriasApi, setCategoriasApi] = useState([]);
	const [temasApi, setTemasApi] = useState([]);
	const [publicosApi, setPublicosApi] = useState([]);
	const [showAlert, setShowAlert] = useState([]);

	// Estado do formulário
	const [form, setForm] = useState({
		nome: '',
		mes: '',
		ano: '',
		publico: '',
		ativo: true,
		upload: null,
		repositorio: '',
		categoria: '', // id selecionado para adicionar
		tema: '',
		publico_alvo: '',
		repositorios: [], // id selecionado para adicionar
		categorias: [], // ids selecionados
		temas: [],
		publicos_alvo: [],
		descricao: '', // ids selecionados
	});
	const [errors, setErrors] = useState({});
	const [showErrorMsg, setShowErrorMsg] = useState(false);
	const [successMsg, setSuccessMsg] = useState(false);
	const [formDisabled, setFormDisabled] = useState(false);
	const [publicDisabled, setPublicDisabled] = useState(false);
	const [uploadAlert, setUploadAlert] = useState(false);
	const [loading, setLoading] = useState(false);

	// Carrega repositórios únicos (limitando ids 1..4)
	useEffect(() => {
		if (Cookies.get('user')) {
			setShowAlert(false);
		} else {
			setShowAlert(true);
		}

		async function loadRepositorios() {
			try {
				const docsResp = await requestBibliotecaRepositorios();
				setRepositoriosUnicos(docsResp);
			} catch (error) {
				setRepositoriosUnicos([]);
			}
		}
		loadRepositorios();
	}, []);

	// Carrega categorias e temas conforme o repositório selecionado
	useEffect(() => {
		let token;
		if (Cookies.get('user')) {
			token = JSON.parse(Cookies.get('user')).token;
		}
		let isMounted = true;
		async function fetchPorRepositorio(repoId) {
			const repoPk = Number(repoId);
			try {
				const repos = await requestBibliotecaRepositorios();
				if (isMounted)
					setRepositoriosApi(Array.isArray(repos) ? repos : []);
			} catch {
				if (isMounted) setRepositoriosApi([]);
			}
			try {
				let cats = [];

				if (form.repositorios.length === 1) {
					const repoId = form.repositorios[0];
					const result = await bibliotecaRepositoriosCategorias(
						repoId,
						token
					);
					cats = Array.isArray(result) ? result : [];
				} else if (form.repositorios.length > 1) {
					const uniqueRepos = [...new Set(form.repositorios)];
					const results = await Promise.all(
						uniqueRepos.map((id) =>
							bibliotecaRepositoriosCategorias(id, token)
						)
					);
					const validResults = results.filter(Array.isArray);

					if (validResults.length > 0) {
						const common = validResults.reduce((acc, curr) => {
							const currIds = new Set(
								curr.map((item) => item.id)
							);
							return acc.filter((item) => currIds.has(item.id));
						});

						cats = Array.from(
							new Map(
								common.map((item) => [item.id, item])
							).values()
						);
					} else {
						cats = [];
					}
				} else {
					cats = await requestBibliotecaCategorias();
				}

				if (isMounted)
					setCategoriasApi(Array.isArray(cats) ? cats : []);
			} catch {
				if (isMounted) setCategoriasApi([]);
			}
			try {
				let tems = [];

				if (form.repositorios.length === 1) {
					tems = await bibliotecaRepositoriosTemas(
						form.repositorios[0],
						token
					);
				} else if (form.repositorios.length > 1) {
					const uniqueRepos = [...new Set(form.repositorios)];
					const results = await Promise.all(
						uniqueRepos.map((id) =>
							bibliotecaRepositoriosTemas(id, token)
						)
					);

					const validResults = results.filter(Array.isArray);

					if (validResults.length > 0) {
						const common = validResults.reduce((acc, curr) => {
							const currNomes = new Set(
								curr.map((item) => item.nome)
							);
							return acc.filter((item) =>
								currNomes.has(item.nome)
							);
						});
						tems = Array.from(
							new Map(
								common.map((item) => [item.nome, item])
							).values()
						);
					} else {
						tems = [];
					}
				} else {
					tems = await requestBibliotecaTemasList({}, token);
				}

				if (isMounted) setTemasApi(Array.isArray(tems) ? tems : []);
			} catch {
				if (isMounted) setTemasApi([]);
			}
			try {
				const publicos = await bibliotecaPublicosAlvos(repoPk);
				if (isMounted)
					setPublicosApi(Array.isArray(publicos) ? publicos : []);
			} catch {
				if (isMounted) setTemasApi([]);
			}
		}
		if (form.repositorios) {
			fetchPorRepositorio(form.repositorios);
		} else {
			setRepositoriosApi([]);
			setCategoriasApi([]);
			setTemasApi([]);
		}
		return () => {
			isMounted = false;
		};
	}, [form.repositorios]);

	// Helpers de relacionamento
	const sameIds = useCallback((a = [], b = []) => {
		if (a.length !== b.length) return false;
		const sa = a.map(Number).sort((x, y) => x - y);
		const sb = b.map(Number).sort((x, y) => x - y);
		for (let i = 0; i < sa.length; i++) if (sa[i] !== sb[i]) return false;
		return true;
	}, []);

	// Listas filtradas para selects (já vêm por repositório)
	const categoriasFiltradas = useMemo(() => {
		if (!form.repositorios) return [];
		return categoriasApi;
	}, [categoriasApi, form.repositorios]);
	const temasFiltrados = useMemo(() => {
		if (!form.repositorios) return [];
		return temasApi || [];
	}, [temasApi, form.repositorios]);

	const publicoFiltrados = useMemo(() => {
		if (!form.repositorios) return [];
		return publicosApi || [];
	}, [publicosApi, form.repositorios]);

	// Opções para os selects
	const anosDisponiveis = [];
	const anoAtual = new Date().getFullYear();
	for (let ano = anoAtual; ano >= 2020; ano--) anosDisponiveis.push(ano);

	const mesesNomes = [
		'Janeiro',
		'Fevereiro',
		'Março',
		'Abril',
		'Maio',
		'Junho',
		'Julho',
		'Agosto',
		'Setembro',
		'Outubro',
		'Novembro',
		'Dezembro',
	];

	const handleUploadPaste = () => {
		if (fileInputRef.current) {
			fileInputRef.current.paste();

			fileInputRef.current.onchange = (event) => {
				const file = event.target.files?.[0];
				if (file) {
					// console.time('⏳ Tempo de upload');

					const reader = new FileReader();

					reader.onloadstart = () => {
						// console.log('📂 Upload iniciado...');
					};

					reader.onloadend = () => {
						// console.timeEnd('⏳ Tempo de upload');
						// console.log('✅ Upload finalizado com sucesso.');
					};

					reader.readAsDataURL(file); // simula o processo de upload/leitura
				}
			};
		}
	};

	const handleUploadClick = () => {
		if (fileInputRef.current) {
			fileInputRef.current.click();

			fileInputRef.current.onchange = (event) => {
				const file = event.target.files?.[0];
				if (file) {
					// console.time('⏳ Tempo de upload');

					const reader = new FileReader();

					reader.onloadstart = () => {
						// console.log('📂 Upload iniciado...');
					};

					reader.onloadend = () => {
						// console.timeEnd('⏳ Tempo de upload');
						// console.log('✅ Upload finalizado com sucesso.');
					};

					reader.readAsDataURL(file); // simula o processo de upload/leitura
				}
			};
		}
	};

	const UploadIcone = require('../../../images/upload.png');

	const handleChange = (e) => {
		const { id, value, files } = e.target;

		if (id !== 'upload') {
			setForm((prev) => ({
				...prev,
				[id]: files ? files[0] : value,
			}));
			setErrors((prev) => ({ ...prev, [id]: false }));
		} else {
			const file = files?.[0];
			if (file) {
				const fileSizeMB = file.size / (1024 * 1024);
				if (fileSizeMB > 20) {
					console.log('❌ Arquivo maior que 20 MB');
					setUploadAlert(true);
					setErrors((prev) => ({ ...prev, upload: true }));
					return; // não seta no form
				} else {
					console.log('✅ Arquivo dentro do limite');
					setUploadAlert(false);
					setForm((prev) => ({
						...prev,
						upload: file,
					}));
					setErrors((prev) => ({ ...prev, upload: false }));
				}
			}
		}
	};

	// Sanitiza categorias/temas ao trocar repositório
	useEffect(() => {
		const allowedCatIds = new Set(
			categoriasFiltradas.map((c) => Number(c.id))
		);
		const newCats = (form.categorias || []).filter((id) =>
			allowedCatIds.has(Number(id))
		);
		const categoriaSelectVal =
			form.categoria && !allowedCatIds.has(Number(form.categoria))
				? ''
				: form.categoria;

		// Valida temas apenas pelo repositório atual
		const allowedTemaIds = new Set(
			(temasApi || []).map((t) => Number(t.id))
		);
		const newTemas = (form.temas || []).filter((tid) =>
			allowedTemaIds.has(Number(tid))
		);
		const temaSelectVal =
			form.tema && !allowedTemaIds.has(Number(form.tema))
				? ''
				: form.tema;

		if (
			!sameIds(newCats, form.categorias) ||
			!sameIds(newTemas, form.temas) ||
			categoriaSelectVal !== form.categoria ||
			temaSelectVal !== form.tema
		) {
			setForm((prev) => ({
				...prev,
				categorias: newCats,
				temas: newTemas,
				categoria: categoriaSelectVal,
				tema: temaSelectVal,
			}));
		}
	}, [
		form.repositorios,
		categoriasFiltradas,
		temasApi,
		form.categoria,
		form.categorias,
		form.temas,
		form.tema,
		sameIds,
	]);

	// Sanitiza temas quando categorias mudarem
	useEffect(() => {
		// Mantém temas apenas se existirem no repositório atual
		const allowedTemaIds = new Set(
			(temasApi || []).map((t) => Number(t.id))
		);
		const newTemas = (form.temas || []).filter((tid) =>
			allowedTemaIds.has(Number(tid))
		);
		const temaSelectVal =
			form.tema && !allowedTemaIds.has(Number(form.tema))
				? ''
				: form.tema;
		if (!sameIds(newTemas, form.temas) || temaSelectVal !== form.tema) {
			setForm((prev) => ({
				...prev,
				temas: newTemas,
				tema: temaSelectVal,
			}));
		}
	}, [temasApi, form.tema, form.temas, sameIds]);

	// Validação
	const validate = () => {
		const newErrors = {};
		if (!form.nome) newErrors.nome = true;
		if (!form.descricao) newErrors.descricao = true;
		if (!form.mes) newErrors.mes = true;
		if (!form.ano) newErrors.ano = true;

		if (!form.publico) newErrors.publico = true;
		if (!form.upload) newErrors.upload = true;
		if (!form.repositorios || form.repositorios.length === 0)
			newErrors.repositorio = true;
		if (!form.categorias || form.categorias.length === 0)
			newErrors.categoria = true;
		// if (!form.temas || form.temas.length === 0) newErrors.tema = true;
		if (!form.publicos_alvo || form.publicos_alvo.length === 0)
			newErrors.publico_alvo = true;
		setErrors(newErrors);
		setShowErrorMsg(Object.keys(newErrors).length > 0);
		return Object.keys(newErrors).length === 0;
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		if (!validate()) return;
		setShowErrorMsg(false);

		try {
			const userCookie = Cookies.get('user');
			const user = userCookie ? JSON.parse(userCookie) : null;
			const token = user?.token;

			const repoId = parseInt(form.repositorios);
			const repoValido = repositoriosUnicos.some(
				(r) => String(r.id) === String(repoId)
			);
			if (!repoValido) {
				alert('Selecione um repositório válido.');
				return;
			}

			const formData = new FormData();
			formData.append('titulo', form.nome);
			formData.append('descricao', form.descricao);
			formData.append('mes', form.mes ? parseInt(form.mes) : null);
			formData.append('ano', form.ano ? parseInt(form.ano) : null);
			formData.append('publico', form.publico === 'true');
			formData.append('ativo', form.ativo === true);
			formData.append('arquivo', form.upload);

			(form.repositorios || [])
				.map((id) => Number(id))
				.filter((id) => !isNaN(id) && id > 0)
				.forEach((id) => formData.append('repositorios', id));

			(form.categorias || [])
				.map((id) => Number(id))
				.filter((id) => !isNaN(id) && id > 0)
				.forEach((id) => formData.append('categorias', id));

			(form.temas || [])
				.map((id) => Number(id))
				.filter((id) => !isNaN(id) && id > 0)
				.forEach((id) => formData.append('temas', id));

			(form.publicos_alvo || [])
				.map((id) => Number(id))
				.filter((id) => !isNaN(id) && id > 0)
				.forEach((id) => formData.append('publico_alvo', id));

			// ⏱️ Início da medição do tempo de requisição
			console.time(
				'⏳ Tempo da requisição requestBibliotecaDocumentosCreate'
			);
			console.log('🚀 Iniciando envio do documento...');
			setLoading(true);

			const resultado = await requestBibliotecaDocumentosCreate(
				formData,
				token
			);

			// ⏱️ Fim da medição do tempo
			console.timeEnd(
				'⏳ Tempo da requisição requestBibliotecaDocumentosCreate'
			);
			console.log('✅ Resposta recebida da API.');
			setLoading(false);

			if (resultado.error) {
				console.error(
					`❌ Erro ao criar documento: ${Object.values(
						resultado.error
					)}`
				);
				alert(
					`Erro ao criar documento. Tente novamente. ${Object.values(
						resultado.error
					)}`
				);
			} else {
				setFormDisabled(true);
				setSuccessMsg(true);
				setTimeout(() => {
					setSuccessMsg(false);
					setFormDisabled(false);
					navigate('/gestao-biblioteca');
				}, 2000);
			}
		} catch (error) {
			console.timeEnd(
				'⏳ Tempo da requisição requestBibliotecaDocumentosCreate'
			); // garante fim do timer mesmo com erro
			console.error('💥 Erro ao enviar documento:', error);
			alert('Erro ao enviar documento. Tente novamente.');
		}
	};

	// Adição/remoção de categorias/temas por ID
	const handleAddRepositorio = () => {
		const id = Number(form.repositorio);
		if (!id || isNaN(id)) return;
		if (!form.repositorios.includes(id)) {
			setForm((prev) => ({
				...prev,
				repositorios: [...prev.repositorios, id],
				repositorio: '',
			}));
		}
	};

	const handleAddCategoria = () => {
		const id = Number(form.categoria);
		if (!id || isNaN(id)) return;
		if (!form.categorias.includes(id)) {
			setForm((prev) => ({
				...prev,
				categorias: [...prev.categorias, id],
				categoria: '',
			}));
		}
	};

	const handleAddTema = () => {
		const id = Number(form.tema);
		if (!id || isNaN(id)) return;
		if (!form.temas.includes(id)) {
			setForm((prev) => ({
				...prev,
				temas: [...prev.temas, id],
				tema: '',
			}));
		}
	};

	const removeRepositorio = (id) => {
		setForm((prev) => ({
			...prev,
			repositorios: prev.repositorios.filter(
				(r) => Number(r) !== Number(id)
			),
		}));
	};

	const removeCategoria = (id) => {
		setForm((prev) => ({
			...prev,
			categorias: prev.categorias.filter((c) => Number(c) !== Number(id)),
		}));
	};

	const removeTema = (id) => {
		setForm((prev) => ({
			...prev,
			temas: prev.temas.filter((t) => Number(t) !== Number(id)),
		}));
	};

	const handleAddPublicos = () => {
		const id = Number(form.publico_alvo);
		if (!id || isNaN(id)) return;

		if (!form.publicos_alvo.includes(id)) {
			setForm((prev) => ({
				...prev,
				publicos_alvo: [...prev.publicos_alvo, id],
				publico_alvo: '', // limpa o select após adicionar
			}));
		}
	};

	const removePublicos = (id) => {
		setForm((prev) => ({
			...prev,
			publicos_alvo: prev.publicos_alvo.filter(
				(p) => Number(p) !== Number(id)
			),
		}));
	};

	const getAllRepositorios = () => form.repositorios || [];
	const getAllCategorias = () => form.categorias || [];
	const getAllTemas = () => form.temas || [];
	const getAllPublicos = () => form.publicos_alvo || [];

	return (
		<div className='flex flex-col mx-auto min-h-screen'>
			<NavBar />
			{/* {console.log(form.repositorios, categoriasFiltradas)} */}
			{showAlert ? (
				<section className='bg-[#004A80] mt-[150px] rounded-md w-[90%] sm:w-[70%] md:w-[60%] lg:w-[50%]  mx-auto my-auto'>
					<div className='py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6'>
						<div className='mx-auto max-w-screen-sm text-center'>
							<h1 className='mb-4 text-white text-5xl sm:text-6xl lg:text-7xl tracking-tight font-extrabold text-primary-600'>
								401
							</h1>
							<p className='mb-10 text-2xl sm:text-3xl md:text-4xl tracking-tight font-bold text-slate-100'>
								Acesso Negado
							</p>
							<p className='mb-7 text-sm sm:text-base md:text-lg font-light text-gray-300'>
								Você não possui permissão para acessar este
								campo. Entre em contato com o administrador(a)
								da sua unidade para solicitação de acesso.
							</p>
							<a
								href='/login'
								className='inline-flex hover:scale-105 transition-transform text-gray-300 bg-primary-600 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-xl px-5 py-2.5 text-center my-4'>
								<span> Volte para a Tela de Login</span>
							</a>
						</div>
					</div>
				</section>
			) : (
				<div className='font-inter flex flex-col flex-grow'>
					{/* Título fora do card branco, com fundo cinza */}
					<div className='sm:top-[80px] mt-[80px] pb-4 bg-[#f0f4f8] w-full'>
						<div className='w-[90%] sm:w-[95%] mx-auto items-center max-w-[1136px]'>
							<div className='px-[2px] py-[18px]'>
								<p className='mx-auto md:mx-10 text-[#004A80] font-bold text-center text-2xl sm:text-3xl md:text-4xl mt-14 mb-12 font-roboto'>
									Adicionar Arquivos
								</p>
							</div>
						</div>
					</div>

					{/* Card branco com filtros */}
					<div className='w-full flex justify-center items-center'>
						<div className='w-[95%] max-w-[1136px] mx-auto px-2 sm:px-6 py-6 overflow-x-auto'>
							<button
								type='button'
								className='bg-[#004A80] text-white px-3 py-1.5 rounded-[8px] font-semibold text-sm shadow border border-[#E3E3E3] mb-4'
								onClick={() => navigate('/gestao-biblioteca')}>
								voltar
							</button>
							<form
								className='flex flex-col items-center w-full mt-10'
								onSubmit={handleSubmit}>
								{/* Primeira linha */}
								<div className='flex flex-col sm:flex-row gap-4 sm:gap-6 mb-4 w-full'>
									<div className='flex flex-col flex-[3] min-w-[220px] sm:min-w-[400px]'>
										<label
											className='text-[#204A80] font-semibold mb-1'
											htmlFor='nome'>
											Nome do Arquivo
										</label>
										<input
											id='nome'
											type='text'
											placeholder='Nome do Documento'
											value={form.nome}
											onChange={handleChange}
											className={`bg-white border rounded-[8px] px-3 py-2 outline-none w-full ${
												errors.nome
													? 'border-[#D32F2F]'
													: 'border-[#E3E3E3]'
											}`}
											disabled={formDisabled}
										/>
									</div>
									<div className='flex flex-col flex-1 min-w-[80px]'>
										<label
											className='text-[#204A80] font-semibold mb-1'
											htmlFor='mes'>
											Mês
										</label>
										<select
											id='mes'
											value={form.mes}
											onChange={handleChange}
											className={`bg-white border rounded-[8px] px-3 py-2 outline-none w-full ${
												errors.mes
													? 'border-[#D32F2F]'
													: 'border-[#E3E3E3]'
											}`}
											disabled={formDisabled}>
											<option
												value=''
												disabled
												hidden>
												Mês
											</option>
											{mesesNomes.map((mes, idx) => (
												<option
													key={mes}
													value={idx + 1}>
													{mes}
												</option>
											))}
										</select>
									</div>
									<div className='flex flex-col flex-1 min-w-[60px]'>
										<label
											className='text-[#204A80] font-semibold mb-1'
											htmlFor='ano'>
											Ano
										</label>
										<select
											id='ano'
											value={form.ano}
											onChange={handleChange}
											className={`bg-white border rounded-[8px] px-3 py-2 outline-none w-full ${
												errors.ano
													? 'border-[#D32F2F]'
													: 'border-[#E3E3E3]'
											}`}
											disabled={formDisabled}>
											<option
												value=''
												disabled
												hidden>
												Ano
											</option>
											{anosDisponiveis.map((ano) => (
												<option
													key={ano}
													value={ano}>
													{ano}
												</option>
											))}
										</select>
									</div>
								</div>
								{/* Segunda linha */}
								<div className='flex flex-col sm:flex-row gap-4 sm:gap-6 mb-4 w-full'>
									<div className='flex flex-col  min-w-[120px] sm:min-w-[180px] max-w-[370px]'>
										<label
											className='text-[#204A80] font-semibold mb-1'
											htmlFor='repositorio'>
											Local do Documento
										</label>
										<div className='flex gap-2.5'>
											<select
												id='repositorio'
												value={form.repositorio}
												onChange={(e) => {
													const repositorioId =
														e.target.value;
													setForm((prev) => ({
														...prev,
														repositorio:
															repositorioId,
													}));
													setErrors((prev) => ({
														...prev,
														repositorio: false,
													}));
												}}
												className={`bg-white border rounded-[8px] px-3 py-2 outline-none flex-grow ${
													errors.repositorio
														? 'border-[#D32F2F]'
														: 'border-[#E3E3E3]'
												}`}
												disabled={
													formDisabled ||
													!form.repositorios
												}>
												<option
													value=''
													disabled
													hidden>
													Selecione o repositório
												</option>
												{repositoriosUnicos.map(
													(repositorio) => (
														<option
															key={repositorio.id}
															value={
																repositorio.id
															}>
															{repositorio.nome}
														</option>
													)
												)}
											</select>
											<button
												type='button'
												className='border border-[#E3E3E3] transition-all duration-300 enabled:hover:bg-[#004A80] enabled:hover:text-[white] rounded-[8px] px-2 py-1 bg-white text-[#204A80]'
												onClick={handleAddRepositorio}
												disabled={
													formDisabled ||
													!form.repositorios
												}>
												+
											</button>
										</div>
										{getAllRepositorios().length > 0 && (
											<div className='flex flex-wrap gap-2 mt-2'>
												{getAllRepositorios().map(
													(repositorioId, index) => {
														const repositorioObj =
															repositoriosApi.find(
																(r) =>
																	String(
																		r.id
																	) ===
																	String(
																		repositorioId
																	)
															);
														const nomeRepositorio =
															repositorioObj
																? repositorioObj.nome
																: repositorioId;
														return (
															<span
																key={`${repositorioId}-${index}`}
																className='bg-[#F4F4F4] text-[#204A80] px-2 py-1 gap-1 rounded text-xs flex items-center border-[1px] border-gray-300'>
																{
																	nomeRepositorio
																}
																<button
																	type='button'
																	onClick={() =>
																		removeRepositorio(
																			repositorioId
																		)
																	}
																	className='ml-1 text-[#D32F2F] text-xs bg-[#fcfcfc] border-gray-200 border-[1px] w-[17px] h-[17px] font-medium transition-all duration-300 hover:bg-gray-300'>
																	x
																</button>
															</span>
														);
													}
												)}
											</div>
										)}
									</div>

									<div className='flex flex-col flex-1 min-w-[120px] sm:min-w-[180px] sm:max-w-[190px]'>
										<label
											className='text-[#204A80] font-semibold mb-1'
											htmlFor='publico'>
											Repositório
										</label>
										<div className='flex flex-row items-center gap-2'>
											<select
												id='publico'
												value={
													form.publico === 'true'
														? 'true'
														: form.publico === ''
														? ''
														: 'false'
												}
												onChange={(e) => {
													setForm((prev) => ({
														...prev,
														publico:
															e.target.value ===
															'true'
																? 'true'
																: e.target
																		.value ===
																  ''
																? ''
																: 'false',
													}));
													setErrors((prev) => ({
														...prev,
														publico: false,
													}));
												}}
												className={`bg-[#F7F9FB] border  rounded-[8px] px-3 py-2 outline-none w-full text-[#004A80] ${
													errors.publico === true
														? 'border-[#D32F2F]'
														: 'border-[#E3E3E3]'
												}`}
												disabled={
													formDisabled ||
													publicDisabled
												}>
												<option
													value=''
													disabled
													hidden>
													Escolha o tipo
												</option>
												<option value='true'>
													Público
												</option>
												<option value='false'>
													Privado
												</option>
											</select>
											{/* <span className="ml-2 text-[#204A80] text-sm font-semibold">{form.publico === true ? 'Público' : 'Privado'}</span> */}
										</div>
									</div>

									<div className='flex flex-col flex-1 min-w-[120px] sm:min-w-[180px]'>
										<label
											className='text-[#204A80] font-semibold mb-1'
											htmlFor='upload'>
											Upload do Arquivo{' '}
											{uploadAlert === true && (
												<span className='text-red-400 text-[12px]'>
													arquivo maior que 20 mb
												</span>
											)}
										</label>
										<div
											className={`flex items-center bg-white border rounded-[8px] px-3 py-2 w-full ${
												errors.upload
													? 'border-[#D32F2F]'
													: 'border-[#E3E3E3]'
											}`}>
											<input
												id='upload'
												type='file'
												ref={fileInputRef}
												style={{ display: 'none' }}
												onChange={handleChange}
											/>
											<input
												type='text'
												disabled
												placeholder='Máximo de 20mb'
												value={
													form.upload
														? form.upload.name
														: ''
												}
												className='bg-transparent outline-none flex-1 text-[#204A80] placeholder-[#A0AEC0]'
												style={{ border: 'none' }}
											/>
											<button
												type='button'
												className='ml-2'
												onClick={handleUploadClick}
												tabIndex={-1}>
												<img
													src={UploadIcone}
													alt='Upload'
													width={24}
													height={24}
													style={{
														display: 'inline-block',
														objectFit: 'contain',
													}}
												/>
											</button>
											<span className='ml-2'>
												<FiLink className='text-[#004A80] w-[23px] h-auto' />
											</span>
										</div>
									</div>

									{/* <div className={` flex flex-col flex-1 max-w-[145px] justify-end`}>
                  <label className={`text-[#204A80] flex  font-semibold mb-1`} htmlFor="publico">Status</label>
                  <div className="flex flex-row items-center gap-2">
                    <div
                      className={`flex transition-all duration-300 gap-4 ${errors.ativo === true?'border-[#d61d1d] border-[1px] p-1 rounded-md':''} `}
                    >
                      <label htmlFor="ativo" className="flex gap-1.5 text-[#757575]">
                         <input
                        onChange={(e) => {
                       setForm((prev) => ({ ...prev, ativo:'true' }));
                        setErrors((prev) => ({ ...prev, ativo: false }));
                        setPublicDisabled(false)
                      }}
                         
                         type="radio" name='status' value='true' id="ativo" ></input>
                         <p>Ativo</p>
                      </label>
                      <label htmlFor="inativo" className="flex gap-1.5 text-[#757575]">
                         <input
                         
                         onChange={(e) => {
                        setForm((prev) => ({ ...prev, publico: 'false', ativo:'false'  }));
                        setErrors((prev) => ({ ...prev, publico: false, ativo:false }));
                        setPublicDisabled(true)
                      }}
                         
                         type="radio" name='status' value='false' id="ativo" ></input>
                         <p>Inativo</p>
                      </label>
                     
                    </div>
                   
                  </div>
                </div>*/}
								</div>

								{/* Terceira linha */}
								<div className='flex flex-wrap gap-4 sm:gap-6 mb-4 w-full'>
									<div className='flex flex-col  w-full max-w-[400px] flex-shrink-0'>
										<label
											className='text-[#204A80] font-semibold mb-1'
											htmlFor='categoria'>
											Categoria
										</label>
										<div className='flex items-center gap-2 w-full'>
											<select
												id='categoria'
												value={form.categoria}
												onChange={(e) => {
													const categoriaId =
														e.target.value;
													setForm((prev) => ({
														...prev,
														categoria: categoriaId,
													}));
													setErrors((prev) => ({
														...prev,
														categoria: false,
													}));
												}}
												className={`bg-white border rounded-[8px] px-3 py-2 outline-none flex-grow ${
													errors.categoria
														? 'border-[#D32F2F]'
														: 'border-[#E3E3E3]'
												}`}
												disabled={
													formDisabled ||
													form.repositorios.length ===
														0 ||
													categoriasFiltradas.length ===
														0
												}>
												<option
													value=''
													disabled
													hidden>
													{categoriasFiltradas.length ===
													0
														? 'Nenhuma categoria disponivel'
														: 'Selecione a categoria'}
												</option>
												{categoriasFiltradas.map(
													(categoria) => (
														<option
															key={categoria.id}
															value={
																categoria.id
															}>
															{categoria.nome}
														</option>
													)
												)}
											</select>
											<button
												type='button'
												className='border border-[#E3E3E3] transition-all duration-300 enabled:hover:bg-[#004A80] enabled:hover:text-[white] rounded-[8px] px-2 py-1 bg-white text-[#204A80]'
												onClick={handleAddCategoria}
												disabled={
													formDisabled ||
													form.repositorios.length ===
														0 ||
													!form.categoria
												}>
												+
											</button>
										</div>
										{getAllCategorias().length > 0 && (
											<div className='flex flex-wrap gap-2 mt-2'>
												{getAllCategorias().map(
													(categoriaId, index) => {
														const categoriaObj =
															categoriasApi.find(
																(c) =>
																	String(
																		c.id
																	) ===
																	String(
																		categoriaId
																	)
															);
														const nomeCategoria =
															categoriaObj
																? categoriaObj.nome
																: categoriaId;
														return (
															<span
																key={`${categoriaId}-${index}`}
																className='bg-[#F4F4F4] text-[#204A80] px-2 py-1 gap-1 rounded text-xs flex items-center border-[1px] border-gray-300'>
																{nomeCategoria}
																<button
																	type='button'
																	onClick={() =>
																		removeCategoria(
																			categoriaId
																		)
																	}
																	className='ml-1 text-[#D32F2F] text-xs bg-[#fcfcfc] border-gray-200 border-[1px] w-[17px] h-[17px] font-medium transition-all duration-300 hover:bg-gray-300'>
																	x
																</button>
															</span>
														);
													}
												)}
											</div>
										)}
									</div>

									{/* Repetir o mesmo padrão para Tema e Público-Alvo */}
									<div className='flex flex-col w-full max-w-[400px] flex-shrink-0'>
										<label
											className='text-[#204A80] font-semibold mb-1'
											htmlFor='tema'>
											Tema
										</label>
										<div className='flex items-center gap-2 w-full'>
											<select
												id='tema'
												value={form.tema}
												onChange={(e) => {
													const temaId =
														e.target.value;
													setForm((prev) => ({
														...prev,
														tema: temaId,
													}));
													setErrors((prev) => ({
														...prev,
														tema: false,
													}));
												}}
												className={`bg-white border rounded-[8px] w-auto   px-3 py-2  outline-none flex-grow ${
													errors.tema
														? 'border-[#D32F2F]'
														: 'border-[#E3E3E3]'
												}`}
												disabled={
													formDisabled ||
													form.repositorios.length ===
														0
												}>
												<option
													value=''
													disabled
													hidden>
													Selecione o tema
												</option>
												{temasFiltrados.map((tema) => (
													<option
														key={tema.id}
														value={tema.id}>
														{tema.nome}
													</option>
												))}
											</select>
											<button
												type='button'
												onClick={handleAddTema}
												className='border border-[#E3E3E3] transition-all duration-300 enabled:hover:bg-[#004A80] enabled:hover:text-[white] rounded-[8px] px-2 py-1 bg-white text-[#204A80]'
												disabled={
													formDisabled ||
													form.repositorios.length ===
														0 ||
													!form.tema
												}>
												+
											</button>
										</div>
										{getAllTemas().length > 0 && (
											<div className='flex flex-wrap gap-2 mt-2'>
												{getAllTemas().map(
													(temaId, index) => {
														const temaObj =
															temasApi.find(
																(t) =>
																	String(
																		t.id
																	) ===
																	String(
																		temaId
																	)
															);
														const nomeTema = temaObj
															? temaObj.nome
															: temaId;
														return (
															<span
																key={`${temaId}-${index}`}
																className='bg-[#F4F4F4] text-[#204A80] px-2 py-1 gap-1 rounded text-xs flex items-center border-[1px] border-gray-300'>
																{nomeTema}
																<button
																	type='button'
																	onClick={() =>
																		removeTema(
																			temaId
																		)
																	}
																	className='ml-1 text-[#D32F2F] text-xs bg-[#fcfcfc] border-gray-200 border-[1px] w-[17px] h-[17px] font-medium transition-all duration-300 hover:bg-gray-300'>
																	x
																</button>
															</span>
														);
													}
												)}
											</div>
										)}
									</div>

									<div className='flex flex-col w-full max-w-[220px] flex-shrink-0'>
										<label
											className='text-[#204A80] font-semibold mb-1'
											htmlFor='publico_alvo'>
											Público-alvo
										</label>
										<div className='flex items-center gap-2 w-full'>
											<select
												id='publico_alvo'
												value={form.publico_alvo}
												onChange={(e) => {
													const publicoId =
														e.target.value;
													setForm((prev) => ({
														...prev,
														publico_alvo: publicoId,
													}));
													setErrors((prev) => ({
														...prev,
														publico_alvo: false,
													}));
												}}
												className={`bg-white border rounded-[8px] px-3 py-2 outline-none flex-grow ${
													errors.publico_alvo
														? 'border-[#D32F2F]'
														: 'border-[#E3E3E3]'
												}`}
												disabled={
													formDisabled ||
													form.repositorios.length ===
														0
												}>
												<option
													value=''
													disabled
													hidden>
													Selecione o Público
												</option>
												{publicoFiltrados.map(
													(publico) => (
														<option
															key={publico.id}
															value={publico.id}>
															{publico.nome}
														</option>
													)
												)}
											</select>
											<button
												type='button'
												className='border border-[#E3E3E3] transition-all duration-300 enabled:hover:bg-[#004A80] enabled:hover:text-[white] rounded-[8px] px-2 py-1 bg-white text-[#204A80]'
												onClick={handleAddPublicos}
												disabled={
													formDisabled ||
													form.repositorios.length ===
														0 ||
													!form.publicos_alvo
												}>
												+
											</button>
										</div>
										{getAllPublicos().length > 0 && (
											<div className='flex flex-wrap gap-2 mt-2'>
												{getAllPublicos().map(
													(publicosId, index) => {
														const publicosObj =
															publicosApi.find(
																(p) =>
																	String(
																		p.id
																	) ===
																	String(
																		publicosId
																	)
															);
														const nomePublicos =
															publicosObj
																? publicosObj.nome
																: publicosId;
														return (
															<span
																key={`${publicosId}-${index}`}
																className='bg-[#F4F4F4] text-[#204A80] px-2 py-1 gap-1 rounded text-xs flex items-center border-[1px] border-gray-300'>
																{nomePublicos}
																<button
																	type='button'
																	onClick={() =>
																		removePublicos(
																			publicosId
																		)
																	}
																	className='ml-1 text-[#D32F2F] text-xs bg-[#fcfcfc] border-gray-200 border-[1px] w-[17px] h-[17px] font-medium transition-all duration-300 hover:bg-gray-300'>
																	x
																</button>
															</span>
														);
													}
												)}
											</div>
										)}
									</div>
								</div>
								<div className='flex flex-col flex-[3] w-full'>
									<label
										className='text-[#204A80] font-semibold mb-1'
										htmlFor='descricao'>
										Descrição
									</label>
									<textarea
										id='descricao'
										placeholder=''
										value={form.descricao}
										onChange={handleChange}
										// maxLength={500}
										className={`bg-white border resize-none rounded-[8px] px-3 py-3  outline-none h-[180px] w-full ${
											errors.descricao
												? 'border-[#D32F2F]'
												: 'border-[#E3E3E3]'
										}`}
										disabled={formDisabled}
									/>
								</div>

								<div className='h-[2px] w-full mt-[28px] mb-8 bg-[#E3E3E3]'></div>

								{showErrorMsg && (
									<div className='text-[#D32F2F] text-center mb-4 font-medium'>
										Preencha os campos em destaque
									</div>
								)}

								{successMsg && (
									<div className='text-[#2E7D32] text-center mb-4 font-medium'>
										Arquivo enviado para a Biblioteca
									</div>
								)}

								<div className='flex justify-center w-full mt-2'>
									<button
										disabled={loading || formDisabled}
										type='submit'
										className='bg-[#FCFCFC] transition-all duration-300 px-6 py-2 rounded-[8px] text-[#757575] enabled:hover:bg-[#004A80] enabled:hover:text-white font-semibold shadow border border-[#E3E3E3]'>
										{loading ? (
											<svg
												aria-hidden='true'
												className='w-[80px] h-6 text-gray-200 animate-spin   fill-blue-600'
												viewBox='0 0 100 101'
												fill='none'
												xmlns='http://www.w3.org/2000/svg'>
												<path
													d='M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z'
													fill='currentColor'
												/>
												<path
													d='M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z'
													fill='currentFill'
												/>
											</svg>
										) : (
											'Enviar Arquivo'
										)}
									</button>
								</div>
							</form>
						</div>
					</div>
				</div>
			)}
		</div>
	);
}
